import { GraphQL } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'
import { ArrangeIcon } from '@hugeicons/core-solid-rounded'

import { extractOptions, Step } from '../types'

export function useFeatureSteps(
  type: GraphQL.IntegrationTypes,
  provider: GraphQL.Providers,
  data?: Record<string, unknown>
): Step[] | undefined {
  const { t } = useLingui()

  const steps: Partial<
    Record<GraphQL.IntegrationTypes, Partial<Record<GraphQL.Providers, Step[]>>>
  > = {
    [GraphQL.IntegrationTypes.Pms]: {
      [GraphQL.Providers.Mews]: [
        {
          id: 'categories',
          icon: ArrangeIcon,
          type: 'form',
          title: t`Room Categories`,
          description: t`The room categories you want to sync with Mews.`,
          fields: [
            {
              type: 'select',
              multi: true,
              label: t`Categories`,
              description: t`Select 1 or more room categories that you would like to sync.`,
              name: 'space_categories',
              required: true,
              options: extractOptions('categories', data)
            }
          ]
        }
      ],
      [GraphQL.Providers.Apaleo]: [
        {
          id: 'unitGroups',
          icon: ArrangeIcon,
          type: 'form',
          title: t`Unit Groups`,
          description: t`The room types you want to sync with Apaleo.`,
          fields: [
            {
              type: 'select',
              multi: true,
              label: t`Unit Groups`,
              description: t`Select 1 or more unit groups that you would like to sync.`,
              name: 'unit_groups',
              required: true,
              options: extractOptions('unit_groups', data)
            }
          ]
        }
      ],
      [GraphQL.Providers.Stayntouch]: [
        {
          id: 'roomTypes',
          icon: ArrangeIcon,
          type: 'form',
          title: t`Room Types`,
          description: t`The room types you want to sync with StayNTouch.`,
          fields: [
            {
              type: 'select',
              multi: true,
              label: t`Room Types`,
              description: t`Select 1 or more room types that you would like to sync.`,
              name: 'room_types',
              required: true,
              options: extractOptions('room_types', data)
            }
          ]
        }
      ]
    }
  }

  return steps[type]?.[provider]
}
